// extracted by mini-css-extract-plugin
export var paginator = "Paginator-module--paginator--1gMy_";
export var paginatorItem = "Paginator-module--paginatorItem--3jYti";
export var active = "Paginator-module--active--3hBkg";